import { render, staticRenderFns } from "./articles-filter-date.vue?vue&type=template&id=1d826c96&scoped=true"
import script from "./articles-filter-date.vue?vue&type=script&lang=js"
export * from "./articles-filter-date.vue?vue&type=script&lang=js"
import style0 from "./articles-filter-date.vue?vue&type=style&index=0&id=1d826c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d826c96",
  null
  
)

export default component.exports